// extracted by mini-css-extract-plugin
module.exports = {"general":"general--2zBHz","wrapper":"wrapper--2__Ee","content":"content--1UGHh"};